import { useState } from 'react';
import DraggableItem from './DraggableItem';

const ReorderableList = ({ items, handleDragOrder }) => {
  const [list, setList] = useState(items);

  const moveItem = (fromIndex, toIndex) => {
    const updatedList = [...list];
    const [movedItem] = updatedList.splice(fromIndex, 1);
    updatedList.splice(toIndex, 0, movedItem);
    setList(updatedList);
    handleDragOrder(updatedList);
  };

  return (
    <div style={{ width: '100%' }}>
      {list.map((item, index) => (
        <DraggableItem
          key={item.emailColumnId}
          id={item.emailColumnId}
          item={item}
          index={index}
          moveItem={moveItem}
        />
      ))}
    </div>
  );
};

export default ReorderableList;
